import React from "react";
import { licenseProductNames } from "license/helper/licenseProducts";
const ProductsCell = ({ products, licenseType }) => /* @__PURE__ */ React.createElement(React.Fragment, null, licenseProductNames({ products, license_type: licenseType }).map((name) => /* @__PURE__ */ React.createElement("p", { key: name }, name)));
export default ProductsCell;
